import React, { useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import { useHistory } from "react-router-dom"; // useHistory와 useLocation 추가
import { Typography, Stack, Box } from "@mui/material";
import { List } from "./Styled/LanguageStyled";
import { inject, observer } from "mobx-react";
import { usePenStatus } from "../../nativebridge/PenStatus";
import { customSendSetting } from "../../nativebridge/JsToNative";
import CommonLoading from "@/views/CommonComponent/CommonLoading";
import ComfirmDialog from "@/views/CommonComponent/ComfirmDialog";
import SettingSubpageHeader from "./components/SettingSubpageHeader";
import {
  NativeToJsBridge,
  NativeToJsEventName,
  NativeToJsEventOnDeviceConnected,
} from "../../nativebridge/NativeToJs";
import { useToast } from '../../components/useToast';

// import languageMap from "./Setting";

function SpeakingLanguageSetting(props) {
  const { intl } = props;
  const languageMap = {
    US: "English",
    KR: "한국어",
    JP: "日本語",
    CN: "简体中文",
    ES: "Español",
    DE: "Deutsch",
    XA: "ٱلسُّعُوْدِيَّة",
  };
  const history = useHistory();
  const { globalPenStatus, setGlobalPenStatus } = usePenStatus();
  const [loading, setLoading] = useState(false);
  const [disconnect, setDisconnect] = React.useState(false);
  const { showErrorToast } = useToast();

  const handleBack = () => {
    history.goBack();
  };

  const onDeviceDisConnected = () => {
    setGlobalPenStatus((prevStatus) => ({
      ...prevStatus, // 현재 상태를 복사
      isConnect: false, // isConnect 속성만 변경
    }));
    setDisconnect(true);
    showErrorToast(intl.formatMessage({ id: "disconnect_dialog_Title" }));
    
    // 토스트 메시지를 3초 동안 보여준 후 설정 페이지로 이동
    setTimeout(() => {
      history.push('/setting');
    }, 3000);
  };


  useEffect(() => {
    console.log(globalPenStatus.deviceInfo.lang_speaking);
    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onDeviceDisConnected,
      async (event) => {
        // const jsonStr = event;
        onDeviceDisConnected();
      }
    );

    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onCustomSendResult,
      async (event) => {
        const jsonStr = event;
        setLoading(false);
      }
    );
    return () => {
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onCustomSendResult
      );
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onDeviceDisConnected
      );
    };
  }, []);

  const handleLanguageChange = (languageCode) => {
    console.log(`handleLanguageChange languageCode=${languageCode}`);

    if (globalPenStatus.deviceInfo.lang_speaking !== languageCode) {
      setGlobalPenStatus((prevStatus) => ({
        ...prevStatus,
        deviceInfo: {
          ...prevStatus.deviceInfo, // spread the previous deviceInfo object
          lang_speaking: languageCode, // update lang_main
        },
      }));
      const settingData = {
        messageType: "POKORO2_Settings",
        payload: {
          lang_system: globalPenStatus.deviceInfo.lang_system,
          lang_speaking: languageCode,
          lang_listening_main: globalPenStatus.deviceInfo.lang_listening_main,
          lang_listening_sub: globalPenStatus.deviceInfo.lang_listening_sub,
        },
      };
      setLoading(true);
      customSendSetting(JSON.stringify(settingData));
    }
  };

  return (
    <>
      <Stack width="100%">
        <SettingSubpageHeader
          onBack={handleBack}
          title={intl.formatMessage({ id: "speaking_language_settings" })}
          description={intl.formatMessage({ id: "language_setting_description" })}
        />
        <Stack pt={4} gap={1}>
          {Object.keys(languageMap).map((languageCode) => (
            <List
              key={languageCode}
              selected={globalPenStatus.deviceInfo.lang_speaking === languageCode}
              onClick={() => handleLanguageChange(languageCode)}
            >
              <Stack>
                <Typography variant="body1">{intl.formatMessage({ id: `${languageCode}` })}</Typography>
                <Typography variant="caption" color='#757575'>{languageMap[languageCode]}{" "}</Typography>
              </Stack>
              {/* 국가 코드에 대응하는 언어 이름 표시 */}
            </List>
          ))}
        </Stack>
      </Stack>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 9999,
          }}
        >
          <CommonLoading text={intl.formatMessage({ id: "setting_sending" })} />
          {/* 세팅 전송 중입니다... */}
        </div>
      )}
    </>
  );
}

export default injectIntl(
  inject("authStore")(observer(SpeakingLanguageSetting))
);
